import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LineChartBiaxial from '../../../components/charts/LineChartBiaxial';
import BarChartBasic from '../../../components/charts/BarChartBasic';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            {...other}
            style={{ width: '100%' }} // Ensure full width for tab panels
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}

export default function HorizontalTabs({ combinedData, combinedDepartureData, barChartData }) {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Tabs value={value} onChange={handleChange} centered>
                <Tab label="Charts" {...a11yProps(0)} />
                <Tab label="Bar Chart" {...a11yProps(1)} />
            </Tabs>
            <TabPanel value={value} index={0}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h3" >
                            Car and Ship Departures per Month
                        </Typography>
                        <LineChartBiaxial
                            data={combinedDepartureData}
                            height={400}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h3" >
                            Car and Ship Arrivals per Month
                        </Typography>
                        <LineChartBiaxial
                            data={combinedData}
                            height={400}
                        />
                    </Grid>
                </Grid>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h3" >
                            Total numbers of Cars planned, departed, and arrived per Month
                        </Typography>
                        <BarChartBasic
                            dataset={barChartData.dataset}
                            series={barChartData.series}
                            xAxis={barChartData.xAxis}
                            height={400}
                        />
                    </Grid>
                </Grid>
            </TabPanel>
        </Box>
    );
}
